<script setup lang="ts">
import { AlertDialogTitle } from 'reka-ui'
import { cn } from '@/utils/shadcn'

const props = defineProps<{ class?: unknown }>()
</script>

<template>
    <AlertDialogTitle :class="cn('text-base font-semibold text-foreground mb-2', props.class)">
        <slot />
    </AlertDialogTitle>
</template>
